
namespace RioERP.Orders {

    @Serenity.Decorators.registerClass()
    export class TeacherPayoutDialog extends Serenity.EntityDialog<TeacherPaymentsRow, any> {
        protected getFormKey() { return TeacherPayoutForm.formKey; }
        protected getIdProperty() { return TeacherPaymentsRow.idProperty; }
        protected getLocalTextPrefix() { return TeacherPaymentsRow.localTextPrefix; }
        protected getService() { return TeacherPaymentsService.baseUrl; }

        protected form = new TeacherPayoutForm(this.idPrefix);

        public rowids: string;
        private checkgrid: OrderFranchiseeShareCalculationGrid;
        constructor(gridToRefresh, FormMode, selectedids) {

            super();

            this.form = new TeacherPayoutForm(this.idPrefix);
            //debugger;
            this.rowids = selectedids;

            this.form.TeacherId.change(e => {
                debugger;
                var vfranchiseeId = this.form.TeacherId.value;

                if (Q.isEmptyOrNull(vfranchiseeId)) {
                    //this.setShippingProviderDetails({});
                }
                else {
                    try {
                        debugger;
                        TeacherPaymentsService.GetTeacherTotalShare({
                            rowIds: this.rowids,
                            //      
                        }, response => {
                            this.form.PaidAmount.value = response.PaidAmount;
                            
                        });
                    } catch (e) {

                    }
                }
            });
        }

        loadEntity(entity: FranchiseePaymentsRow) {
            //debugger;
            super.loadEntity(entity);
            //debugger;
            this.form.RowIds.value = this.rowids;
            Serenity.EditorUtils.setReadOnly(this.form.PaidAmount, true);           
        }

        onSaveSuccess(response) {
            super.onSaveSuccess(response);
            //debugger;
            if (this.form.RowIds.value != "") {
                Q.notifySuccess("Added sucessfully");
                //this.Questionsgrid.rowSelection.resetCheckedAndRefresh();
                //this.Questionsgrid.refresh();
            }

        }
    }
}